'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _SearchIcon = require('./SearchIcon');

var _SearchIcon2 = _interopRequireDefault(_SearchIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _SearchIcon2.default;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/SearchIcon/index.js
// module id = 323
// module chunks = 0